import { ReactElement } from "react";

import backgroundButtonWeb from "../../../assets/images/buttonEmpty/button-empty-web-large.png";
import backgroundButtonIpad from "../../../assets/images/buttonEmpty/button-empty-ipad-large.png";

import styles from "./ButtonMintStage.module.scss";

interface IProps {
  text: string;
  alt: string;
  callback?: () => void;
  disabled?: boolean;
}

const ButtonMintStage = ({
  text,
  alt,
  callback,
  disabled,
}: IProps): ReactElement => (
  <div className={styles.contentButton} onClick={callback}>
    <img
      src={backgroundButtonWeb}
      className={styles.backgroundButtonWeb}
      alt={alt}
      role="button"
    />
    <img
      src={backgroundButtonIpad}
      className={styles.backgroundButtonIpad}
      alt={alt}
      role="button"
    />
    <div className={disabled ? styles.contentDisabled : styles.content}>
      <p>{text}</p>
    </div>
  </div>
);

export default ButtonMintStage;
